module.exports = __webpack_public_path__ + "static/media/background.fdad012f.jpg";